export type RainfallRow = {
  label: string;
  dateTime: string;
  dams: {
    id: string;
    label: string;
    before: number;
    after: string | number;
  }[];
};

export type QoutAllRow = {
  label: string;
  dateTime: string;
  dams: {
    id: string;
    label: string;
    before: number;
    after: string | number;
  }[];
};

export const CustomCalculationView = {
  /** 降雨条件設定 */
  SettingRainfallConditions: 'SettingRainfallConditions',
  /** 放流量条件設定 */
  SettingQoutAllConditions: 'SettingQoutAllConditions',
  /** 降雨計算結果表示 */
  RainfallResult: 'RainfallResult',
  /** 放流量計算結果表示 */
  QoutAllResult: 'QoutAllResult',
  /** 保存済み結果表示 */
  SavedResult: 'SavedResult',
} as const;

export type CustomCalculationView = (typeof CustomCalculationView)[keyof typeof CustomCalculationView];